{
  "logLevel": "debug",
  "requestLogging": true,
  "responseLogging": true,
  "artilleryScenarioLogging": false,
  "artilleryScenarioLoggingThinkThreshold": 600,
  "apiSite": "https://dev.data.cms.gov",
  "useMockAdapter": false,
  "mockDelayResponse": 1500,
  "mapBoxAccessToken": "pk.eyJ1Ijoic2VtYW50aWNiaXRzIiwiYSI6ImNrbHRuZWluaDA3angycHFmc2JwczRiY3IifQ.JySzSes9gdSCE1EHqjBPUA",
  "mapBoxStateAbbrStyle": "mapbox://styles/semanticbits/ckuzkwhsf0iiy14la0wc4yidb",
  "mapBoxCountyStyle": "mapbox://styles/semanticbits/ckst26zdo3rtl17qpe3jx6vyd",
  "mapBoxCbsaStyle": "mapbox://styles/semanticbits/ckvrbtcm0eavc14qwbxjkjnl6"
 }
